import { BarChart } from '@mantine/charts';
import { Paper } from 'src/design/atoms/Paper';
import { Text } from 'src/design/atoms/Text';
import { Title } from 'src/design/atoms/Title';
import React, { useMemo } from 'react';
import { BackgroundJobHistoryPointDto } from 'src/api/FiretrolApiClient';
import { formatDate } from 'src/utils';

export interface IBackgroundJobHistoryChartProps {
  hourlyHistory: BackgroundJobHistoryPointDto[];
}

export const BackgroundJobHistoryChart: React.FC<
  IBackgroundJobHistoryChartProps
> = ({ hourlyHistory }) => {
  const data = useMemo(
    () =>
      hourlyHistory.map((point) => ({
        hour: formatDate(point.hour, 'HH:mm'),
        Succeeded: point.succeeded,
        Failed: point.failed,
      })),
    [hourlyHistory],
  );

  return (
    <Paper p="md" withBorder>
      <Title order={5} mb="sm">
        Last 24 Hours
      </Title>
      {data.length === 0 ? (
        <Text c="dimmed" size="sm">
          No job history yet.
        </Text>
      ) : (
        <BarChart
          h={240}
          data={data}
          dataKey="hour"
          series={[
            { name: 'Succeeded', color: 'green' },
            { name: 'Failed', color: 'red' },
          ]}
          tickLine="y"
          gridAxis="xy"
          withLegend
        />
      )}
    </Paper>
  );
};
